import { get } from "../axios";

function buildQuery(params) {
  const query = [];
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") {
      query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });
  return query.length ? `?${query.join("&")}` : "";
}

export const getMexcTradingRobotConfigs = async (params) =>
  get(
    process.env.VUE_APP_BACKEND_API_URL +
      "/MexcTradingRobotConfig/GetAll" +
      buildQuery({
        MaxResultCount: 200,
        SkipCount: 0,
        Sorting: "id desc",
        ...params,
      })
  );

export const getMexcTradingRobotTradeOrders = async (params) =>
  get(
    process.env.VUE_APP_BACKEND_API_URL +
      "/MexcTradingRobotTradeOrder/GetAll" +
      buildQuery({
        MaxResultCount: 500,
        SkipCount: 0,
        Sorting: "id desc",
        ...params,
      })
  );
